import List from "@/components/list";
import router from "@/router";

const Table = (args) => {
  const { listeners } = args;
  // const RCSelectionChange = listeners["selection-change"] || function () { };
  
  // 学员考勤
  function goClassGroup(onlineClass) {
    router.push({
      path: "/attendanceManage/attendance",
      query: { classId: onlineClass.uuid, childId: onlineClass.classChildId, classStatus: args.props.classStatus },
    });
  }

  const Deal = ({ props: { vo } }) => {
    const onlineClass = vo.row;
    const dealConf = [
      ["icon_kaoqin_icon", "学员考勤", () => goClassGroup(onlineClass), ""],
    ]
    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: "小班名称",
      showOverflowTooltip: true,
      prop: "className",
      minWidth: "400",
    },
    {
      label: "操作",
      fixed: "right",
      width: "120",
      render: (vo) => <Deal vo={vo} />,
    },
  ];
  return (
    <List
      {...args}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
